import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Container = styled.div(() =>
  mq({
    height: '100%',
    textAlign: 'center',
    '& > h2': {
      fontSize: defaultTheme.font.size.l,
      color: defaultTheme.color.secondary,
      fontWeight: 'bold',
    },
    '& > p': {
      fontSize: defaultTheme.font.size.s,
      color: defaultTheme.color.secondary,
      marginTop: defaultTheme.spacing.xxl,
      marginBottom: defaultTheme.spacing.l,
      height: ['auto', 'auto', '16px', '16px'],
    },
    '& > img': {
      width: ['295px', '295px', '240px', '240px'],
    },
  }),
);

export const ImageSupplement = styled.div(() =>
  mq({
    width: ['295px', '295px', '240px', '240px'],
    fontSize: defaultTheme.font.size.xs,
    color: defaultTheme.color.secondary,
    textAlign: 'left',
    margin: '0 auto',
    marginTop: defaultTheme.spacing.s,
  }),
);
